import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { IAppState } from "../../../types/stores";
import withModal from "../withModal";
import MaterialModal from "../MaterialModal";
import FieldMetaDataMain from "./FieldMetaDataMain";
import { hideModal } from "../../../actions/actionCreators";
import { FieldMetaData } from "../../../types/stores/adminDesigner";
import { fetchT, IRequestResult, jsonHeaders } from "../../../helpers/typedFetch";
import h from "../../../helpers";
import { setProperty } from "../../../actions/adminDesignerActions";
import { AdminDesignerProperties } from "../../../reducers/adminDesigner/adminDesigner";

interface IFieldMetaDataModal {
    isOpen: boolean;
    modalProps: {
        fieldMetadataFieldKey: number;
        occurs: number;
        handleMetaData: (metadata: Array<FieldMetaData>) => void;
        handleDelete: (id: number) => void;
    };
}

type SaveFieldData = {
    cols: string;
    fieldMetaDataFieldkey: number;
    selectedFields: Array<number>;
};

type UpdateWrkItem = IRequestResult & {
    result: string;
};

const FieldMetaDataModal: React.FC<IFieldMetaDataModal> = ({ modalProps, isOpen }: IFieldMetaDataModal) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("FIELDMETADATA_ADMIN"));
    const [localMetadata, setLocalMetadata] = useState<Array<FieldMetaData>>([]);
    const selectedFields = useSelector<IAppState, Array<number>>(state => state.dataConnect.selectedFields || []);

    const handleSave = () => {
        let fieldData: SaveFieldData = {
            cols: JSON.stringify(localMetadata),
            fieldMetaDataFieldkey: modalProps.fieldMetadataFieldKey,
            selectedFields,
        };

        fetchT<UpdateWrkItem>("/Field/UpdateMetaData", "POST", JSON.stringify(fieldData), jsonHeaders)
            .then(data => {
                if (data.result == "-1") {
                    modalProps && modalProps.handleDelete(-1);
                }
            })
            .catch(error => {
                h.error("Error saving metadata.", error);
            });
        dispatch(setProperty(AdminDesignerProperties.fieldMetadata, localMetadata));
        hide();
    };

    const handleMetadata = (data: Array<FieldMetaData>) => {
        setLocalMetadata(data);
    };
    return (
        <MaterialModal
            id="variable-admin-modal"
            isOpen={isOpen}
            onClose={hide}
            onPrimaryButtonRequest={handleSave}
            title="Field Meta Data"
            showPrimaryButton={true}
            primaryButtonText="Save"
            cancelButtonText="Close"
        >
            <FieldMetaDataMain
                occurs={modalProps.occurs}
                onChangeMetadata={handleMetadata}
                fieldMetaDataFieldkey={modalProps.fieldMetadataFieldKey}
            />
        </MaterialModal>
    );
};

export default withModal(FieldMetaDataModal, "FIELDMETADATA_ADMIN");
